import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const Breadcrumb = ({ items, variant = "light" }) => {
  if (!items || items.length === 0) return null;

  const isDark = variant === "dark";

  return (
    <nav
      className={`container-custom pt-2 pb-0 ${isDark ? "max-w-3xl mx-auto px-4" : ""}`}
      aria-label="Breadcrumb"
      data-testid="breadcrumb-nav"
    >
      <ol className="flex items-center gap-1.5 text-sm flex-wrap">
        <li>
          <Link
            to="/"
            className={`transition-colors ${isDark ? "text-white/40 hover:text-cyan-400" : "text-slate-400 hover:text-optima-blue"}`}
            data-testid="breadcrumb-home"
          >
            <Home className="w-4 h-4" />
          </Link>
        </li>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const itemKey = item.url ? `bc-${item.url}` : `bc-${item.name}`;
          return (
            <React.Fragment key={itemKey}>
              <li className={isDark ? "text-white/20" : "text-slate-300"}>
                <ChevronRight className="w-3.5 h-3.5" />
              </li>
              <li>
                {isLast || !item.url ? (
                  <span
                    className={`font-medium truncate max-w-[250px] inline-block align-bottom ${isDark ? "text-white/70" : "text-optima-dark"}`}
                    data-testid={`breadcrumb-current`}
                  >
                    {item.name}
                  </span>
                ) : (
                  <Link
                    to={item.url}
                    className={`transition-colors ${isDark ? "text-white/40 hover:text-cyan-400" : "text-slate-500 hover:text-optima-blue"}`}
                    data-testid={`breadcrumb-link-${index}`}
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
